/**
 * Design Tokens for Aion Management Theme
 * 
 * Extends the base comfy theme tokens with Aion Management branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-comfy/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Aion Management brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Aion Management brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Aion Management typography — brand-wide switch to Montserrat for
    // both headings and body copy so `font-heading` / `font-body` utilities
    // and the `--vibe-font-heading` / `--vibe-font-body` CSS variables all
    // resolve to Montserrat everywhere they're used.
    heading: '"Montserrat", sans-serif',
    body: '"Montserrat", sans-serif',
  },
};

export default tokens;
